import React, { useState, useEffect } from "react";
import { Controller } from 'react-hook-form'
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import moment from 'moment';
import { VscChromeClose } from 'react-icons/vsc';

const IncentiveFormItem = ({register, idx, errors, control, remove, offerData}) => {

  const htmlAttributes = { placeholder: "When do they expire?" };

  const [countValue, setCountValue] = useState(0)

  const checkCountDown = (e) => {
    let flag
    if (e.target.value.length < 60 || e.keyCode === 8 || e.keyCode === 46) {
      // setCountValue(e.target.value.length)
      flag = false
    }
    else {
      flag = true
    }

    if (flag) {
      e.preventDefault()
    }
  }

  useEffect(()=>{
    if (offerData) {
      setCountValue(offerData.offer_name.length)
    }
  }, [offerData])

  return (
    <div className="my-3 form-row">
      <div className="col-md-4">
        <input
          type="text"
          className="form-control"
          onKeyDown={checkCountDown}
          onKeyUp={e => setCountValue(e.target.value.length)}
          placeholder="What's the unique deal?"
          {...register(`incentive_offer.${idx}.offer_name`, {
            required: "This is required.",
            maxLength: {
              value: 60,
              message: "Maximum character limit is 60",
            },
          })}
        />
        <div className="d-flex align-items-center justify-content-between">
          <span className="text-danger font-size-14">
            {errors.incentive_offer &&
              errors.incentive_offer[idx]?.offer_name?.message}
            {
              countValue === 60 &&
              "Maximum character limit is 60"
            }
          </span>
          <span className="text-danger" style={{fontSize: '12px', marginTop: '3px'}}>{countValue}/60</span>
        </div>
      </div>
      <div className="col-md-3">
        <input
          type="number"
          className="form-control"
          placeholder="No. of vouchers available"
          {...register(`incentive_offer.${idx}.uses_limit`, {
            required: "This is required.",
          })}
        />
        <span className="text-danger font-size-14">
          {errors.incentive_offer &&
            errors.incentive_offer[idx]?.uses_limit?.message}
        </span>
      </div>
      <div className="col-md-4">
        <Controller
          render={({ field }) => (
            <DateTimePickerComponent
              format="dd-MM-yyyy hh:mm"
              id="datetimepicker"
              htmlAttributes={htmlAttributes}
              cssClass="date-time-input customClass"
              value={field.value}
              min={new Date()}
              onChange={(e) =>
                field.onChange(
                  moment(e.target.value).format("YYYY-MM-DD HH:mm")
                )
              }
            />
          )}
          name={`incentive_offer.${idx}.expire_in`}
          control={control}
          rules={{ required: "This is required." }}
        />
        <span className="text-danger font-size-14">
          {errors.incentive_offer &&
            errors.incentive_offer[idx]?.expire_in?.message}
        </span>
      </div>
      <div className="col-md-1">
        <button
          type="button"
          onClick={() => remove(idx)}
          className="btn btn-danger btn-sm"
        >
          <VscChromeClose size={20} />
        </button>
      </div>
    </div>
  );
};

export default IncentiveFormItem;
